// /src/store/thirdPartyStreamingSystemManagment/types.ts

import { ThirdPartyStreamingChannel ,
         ThirdPartyStreamingService } from '../../dataTypes/broadcastingManagment/types_thirdPartyStreamingSystem';

export const FETCH_STREAMING_SERVICES_REQUEST = 'FETCH_STREAMING_SERVICES_REQUEST';
export const FETCH_STREAMING_SERVICES_SUCCESS = 'FETCH_STREAMING_SERVICES_SUCCESS';
export const FETCH_STREAMING_SERVICES_FAILURE = 'FETCH_STREAMING_SERVICES_FAILURE';

export const FETCH_STREAMING_CHANNELS_REQUEST = 'FETCH_STREAMING_CHANNELS_REQUEST';
export const FETCH_STREAMING_CHANNELS_SUCCESS = 'FETCH_STREAMING_CHANNELS_SUCCESS';
export const FETCH_STREAMING_CHANNELS_FAILURE = 'FETCH_STREAMING_CHANNELS_FAILURE';

export interface ThirdPartyStreamingState {
  loading: boolean;
  services: ThirdPartyStreamingService[];
  channels: ThirdPartyStreamingChannel[];
  error: string | null;
  lastFetchTimestamp: number;
}

export const initialState: ThirdPartyStreamingState = {
  loading: false,
  services: [],
  channels: [],
  error: null,
  lastFetchTimestamp: 0,
};

export interface FetchStreamingServicesRequestAction {
  type: typeof FETCH_STREAMING_SERVICES_REQUEST;
}

export interface FetchStreamingServicesSuccessAction {
  type: typeof FETCH_STREAMING_SERVICES_SUCCESS;
  payload: ThirdPartyStreamingService[];
}

export interface FetchStreamingServicesFailureAction {
  type: typeof FETCH_STREAMING_SERVICES_FAILURE;
  payload: string;
}

export interface FetchStreamingChannelsRequestAction {
  type: typeof FETCH_STREAMING_CHANNELS_REQUEST;
}

export interface FetchStreamingChannelsSuccessAction {
  type: typeof FETCH_STREAMING_CHANNELS_SUCCESS;
  payload: ThirdPartyStreamingChannel[];
}

export interface FetchStreamingChannelsFailureAction {
  type: typeof FETCH_STREAMING_CHANNELS_FAILURE;
  payload: string;
}

export type ThirdPartyStreamingActionTypes =
  | FetchStreamingServicesRequestAction
  | FetchStreamingServicesSuccessAction
  | FetchStreamingServicesFailureAction
  | FetchStreamingChannelsRequestAction
  | FetchStreamingChannelsSuccessAction
  | FetchStreamingChannelsFailureAction;
